import { createReducer, on } from '@ngrx/store';
import { GetDesign, GetDesignFailure, GetDesignSuccess } from './design.action';
import { state } from '@angular/animations';

export interface designButtonState {
  primary: string;
  danger: string;
  secondary: string;
  disable: string;
}
export const Initialstate: designButtonState = {
  primary: 'btn btn-sm btn-primary',
  danger: 'btn btn-sm btn-danger',
  secondary: 'btn btn-sm btn-secondary',
  disable: 'btn btn-sm btn-disable',
};

export const Designreducer = createReducer(
  Initialstate,
  on(GetDesign, (state) => ({ ...state })),
  on(GetDesignSuccess, (state, { DesignMod }) => {
    let btnlist = DesignMod.filter((x) => x.elementName == 'button');
    if (btnlist.length > 0) {
      return {
        ...state,
        primary: btnlist.filter((x) => x.elementtype == 'primary')[0]
          .appliedClass,
        secondary: btnlist.filter((x) => x.elementtype == 'secondary')[0]
          .appliedClass,
        danger: btnlist.filter((x) => x.elementtype == 'danger')[0]
          .appliedClass,
        disable: btnlist.filter((x) => x.elementtype == 'disable')[0]
          .appliedClass,
      };
    } else return { ...state };
  }),
  on(GetDesignFailure, (state, { error }) => {
    return { ...state };
  })
);
